import React from "react";
import { useSelector } from "react-redux";
import style from "./measurementStatus.module.scss";
import { Button } from "../../../primary";
import { MeasurementLoader } from "./measurementLoader";
import { hasAnyValue } from "../../../../utils";

export const MeasurementStatus = ({ showMeasurementModal, pendingRetires, maxPendingRetries, disabled }) => {
  const { measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || { loading: false, measurementData: null };
  const status = measurementData?.status;

  const errorStatus = status === "error" || status === "no_measurements";

  const measurmentObj = {
    surfaceArea: measurementData?.surfaceArea,
    length: measurementData?.length,
    width: measurementData?.width,
    depth: measurementData?.depth,
    volume: measurementData?.volume,
    tunneling: measurementData?.tunneling,
    undermining: measurementData?.undermining,
  };

  return (
    <div className="col pl-4">
      <div>
        <div className="mb-3">
          {status === "pending" && !measurementData?.measurementRetry && (
            <>
              <MeasurementLoader pendingRetires={pendingRetires} maxPendingRetries={maxPendingRetries} />
            </>
          )}
          {status === "pending" && measurementData?.measurementRetry && (
            <div style={{ textAlign: "center" }} className={`${style.dim_man_p}`}>
              Something went wrong, tap to{" "}
              <Button
                type="button"
                value="Retry"
                classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                id="autoMeasurement"
                onClick={() => {
                  showMeasurementModal("PlaceDot");
                }}
                disabled={disabled}
              />{" "}
            </div>
          )}

          {errorStatus && !hasAnyValue(measurmentObj) && (
            <p className={`${style.dim_man_p}`}>
              Enter{" "}
              <Button
                type="button"
                value="Dimensions"
                id="autoMeasurement"
                classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                onClick={() => showMeasurementModal("Dimensions")}
                disabled={disabled}
              />{" "}
              manually.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
